


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Debounced } from '@/utils/debounced';
import { searchUsersById, searchUsersByName } from '@/utils/user';

type IUserInfo = IUser.IResponse.IUserDetailInfo;

@Component
export default class SelectUser extends Vue {
  @Prop({default: () => []}) private excludeUserIds!: string[];
  private fetching: boolean = false;
  private defaultOption: IUserInfo[] = [];
  private debouncedFetchUser: (
    searchVal: string,
  ) => void = new Debounced().use(this.searchUser, 1000); // 节流函数
  get userOptions() {
    return this.defaultOption.filter((user) => !this.excludeUserIds.includes(user.id));
  }
  public searchUserById(userId: string) {
    this.defaultOption = searchUsersById(userId);
  }
  // 处理选项改变
  private handleChange(value?: string | string[]) {
    this.$emit('change', value);
  }
  private fetchUser(searchVal: string) {
    this.debouncedFetchUser(searchVal);
  }
  private searchUser(searchVal: string) {
    this.defaultOption = searchUsersByName(searchVal.trim());
  }
}
